import { render, staticRenderFns } from "./newMode.vue?vue&type=template&id=a14f584c&scoped=true&"
import script from "./newMode.vue?vue&type=script&lang=js&"
export * from "./newMode.vue?vue&type=script&lang=js&"
import style0 from "./newMode.vue?vue&type=style&index=0&id=a14f584c&lang=scss&scoped=true&"
import style1 from "./newMode.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a14f584c",
  null
  
)

export default component.exports